import { Empty, Spin } from 'antd';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { WorkspacesStore } from '../../../DataSource/Stores/Cabinet/WorkspacesStore';
import NotFound from '../../NotFound';
import Input from '../../ui/Input';
import Item, { CATEGORY_LABELS } from '../Workspaces/Item';
import ProfileCard from './ProfileCard';
import * as styles from './index.module.scss';

export interface WorkspacesItemProps {
  name?: string;
  _id?: string;
  userIds?: [];
  roles?: Record<string, never> | undefined;
}

const Main = () => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    WorkspacesStore.getList().catch((e) => {
      console.error(e);
    });
  }, []);

  const filteredWorkspaces = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return WorkspacesStore.dataListWork;

    return WorkspacesStore.dataListWork.filter((workspace) => {
      const categoryLabel = CATEGORY_LABELS[workspace.category] ?? workspace.category;
      return (
        workspace.name.toLowerCase().includes(normalizedQuery) ||
        categoryLabel.toLowerCase().includes(normalizedQuery)
      );
    });
  }, [query, WorkspacesStore.dataListWork]);

  if (!WorkspacesStore.getloading && WorkspacesStore.getError) return <NotFound />;

  const totalCount = WorkspacesStore.dataListWork.length;
  const hasQuery = query.trim().length > 0;

  return (
    <div className={styles.page}>
      <ProfileCard />

      <div className={styles.header}>
        <h2 className={styles.title}>Рабочие пространства</h2>
        {!WorkspacesStore.loading && totalCount > 0 && (
          <p className={styles.subtitle}>
            {hasQuery
              ? `Найдено ${filteredWorkspaces.length} из ${totalCount}`
              : `Всего ${totalCount}`}
          </p>
        )}
      </div>

      {!WorkspacesStore.loading && totalCount > 0 && (
        <div className={styles.toolbar}>
          <Input
            className={styles.searchInput}
            width="100%"
            placeholder="Поиск по названию или типу..."
            icon="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      )}

      {WorkspacesStore.loadingError && (
        <div className={styles.error}>Не удалось загрузить список</div>
      )}

      {WorkspacesStore.loading ? (
        <div className={styles.loading}>
          <Spin size="large" />
        </div>
      ) : totalCount === 0 ? (
        <Empty className={styles.empty} description="Рабочие пространства не найдены" />
      ) : filteredWorkspaces.length === 0 ? (
        <Empty
          className={styles.empty}
          description={`Ничего не найдено по запросу «${query.trim()}»`}
        />
      ) : (
        <div className={styles.grid}>
          {filteredWorkspaces.map((workspace) => (
            <Item workspace={workspace} key={workspace._id} />
          ))}
        </div>
      )}
    </div>
  );
};

export default observer(Main);
